import { Phone } from "lucide-react";
import { scrollTo } from "@/App";

const links = [
    { label: "Process", target: "#process" },
    { label: "Services", target: "#services" },
    { label: "Why Us", target: "#trust" },
    { label: "Areas", target: "#coverage" },
    { label: "FAQ", target: "#faq" },
];

export default function Header() {
    return (
        <header className="fixed top-0 left-0 right-0 z-50 bg-tarmac/90 backdrop-blur-md border-b border-ash">
            <div className="flex items-stretch justify-between h-16">
                <button
                    data-testid="nav-logo"
                    onClick={() => scrollTo(0)}
                    className="flex items-center gap-2 px-5 sm:px-8 border-r border-ash"
                >
                    <span className="w-3 h-3 bg-amber inline-block" />
                    <span className="font-display text-xl tracking-wide uppercase">
                        Drop Kerbs <span className="text-amber">UK</span>
                    </span>
                </button>

                <nav className="hidden md:flex items-stretch">
                    {links.map((l) => (
                        <button
                            key={l.label}
                            data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}-link`}
                            onClick={() => scrollTo(l.target)}
                            className="px-6 font-mono text-xs tracking-[0.2em] uppercase text-grit hover:text-paper border-l border-ash transition-colors duration-200"
                        >
                            {l.label}
                        </button>
                    ))}
                    <a
                        data-testid="nav-call-link"
                        href="tel:+447971124650"
                        className="hidden lg:flex items-center gap-2 px-6 font-mono text-xs tracking-[0.2em] uppercase text-grit hover:text-paper border-l border-ash transition-colors duration-200"
                    >
                        <Phone size={14} /> 07971 124 650
                    </a>
                    <button
                        data-testid="nav-get-quote-btn"
                        onClick={() => scrollTo("#quote")}
                        className="px-8 bg-amber text-tarmac font-mono text-xs tracking-[0.2em] uppercase font-bold hover:bg-paper transition-colors duration-200 border-l border-ash"
                    >
                        Get Quote
                    </button>
                </nav>

                <button
                    data-testid="nav-get-quote-btn-mobile"
                    onClick={() => scrollTo("#quote")}
                    className="md:hidden px-6 bg-amber text-tarmac font-mono text-xs tracking-[0.2em] uppercase font-bold"
                >
                    Get Quote
                </button>
            </div>
        </header>
    );
}
